import React from "react";
import { useTranslation } from "react-i18next";

import useStyles from "./FmBack.style";

interface FmBackProps {
    onClick?: () => void;
}

const FmBack = ({ onClick }: FmBackProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.container} onClick={onClick}>
            <div>
                <img src={"/multi-match/assets/skip.png"} alt='skip' className={classes.img} />
            </div>
            <div className={classes.title}>{t("back")}</div>
        </div>
    );
};

export default FmBack;
